const infoWinCircuit = (circuit) => {
  return ` <strong>
                <span style="color: #F64E60; font-weight: bold;">actualizacion:</span> ${circuit.actualizacion} <br> 
                <span style="color: #F64E60; font-weight: bold;">codigo circuito:</span> ${circuit.codigo_circuito} <br> 
                <span style="color: #F64E60; font-weight: bold;">codigo elemento:</span> ${circuit.codigo_elemento} <br> 
                <span style="color: #F64E60; font-weight: bold;">estado normal:</span> ${circuit.estado_normal} <br> 
                <span style="color: #F64E60; font-weight: bold;">estado real:</span> ${circuit.estado_real} <br> 
                <span style="color: #F64E60; font-weight: bold;">fases:</span> ${circuit.fases} <br> 
                <span style="color: #F64E60; font-weight: bold;">matricula:</span> ${circuit.matricula} <br> 
                <span style="color: #F64E60; font-weight: bold;">nombre_circuito:</span> ${circuit.nombre_circuito} <br> 
                <span style="color: #F64E60; font-weight: bold;">tipo_elemento:</span> ${circuit.tipo_elemento} <br> 
                </strong>`;
};
export default infoWinCircuit;
